/**
 * renderer-map — lookup key → componente widget (R-IMPORT 3 / A3.3).
 *
 * Separado de `registry.tsx` pra Fast Refresh funcionar (lint
 * react-refresh/only-export-components exige só componentes em arquivos .tsx).
 */
import type { ComponentType } from 'react';

import {
  HomeAgendaWidget,
  HomeAprovacoesWidget,
  HomeAtividadesWidget,
  HomeKpisWidget,
} from './home-blocos';
import {
  Acao1NovoChamado,
  Acao3BuscarCliente,
  Chart1Chamados30d,
  Chart3Faturamento6m,
  Fixo1Notificacoes,
  Fixo2TarefasHoje,
  Kpi1ChamadosHoje,
  Lista1MeusChamados,
  type PerfilUsuario,
} from './registry';

interface WidgetProps {
  perfilUsuario: PerfilUsuario;
}

/**
 * FASE-C: só entram aqui widgets que funcionam de verdade. As 11 keys
 * removidas (kpi-2, kpi-4, chart-2, chart-4, lista-2, lista-4, fixo-3,
 * cli-1..cli-4) eram cascas com selo "beta" e o aviso "aguarda implementação
 * backend". Esta lista é o filtro da galeria da Personalização da Home
 * (`fetchWidgetsCatalog`): o catálogo do banco pode ter mais keys, mas só as
 * daqui são oferecidas.
 */
export const WIDGET_RENDERERS: Record<string, ComponentType<WidgetProps>> = {
  'kpi-1': Kpi1ChamadosHoje,
  'chart-1': Chart1Chamados30d,
  'chart-3': Chart3Faturamento6m,
  'lista-1': Lista1MeusChamados,
  'acao-1': Acao1NovoChamado,
  'acao-3': Acao3BuscarCliente,
  'fixo-1': Fixo1Notificacoes,
  'fixo-2': Fixo2TarefasHoje,
  // 07/08/2026 — os blocos da Home clássica, para que a home montada por
  // perfil possa incluir o que a equipe já usa. Embrulham os MESMOS
  // componentes da Home (ver `home-blocos.tsx`), não cópias.
  'home-kpis': HomeKpisWidget,
  'home-agenda': HomeAgendaWidget,
  'home-atividades': HomeAtividadesWidget,
  'home-aprovacoes': HomeAprovacoesWidget,
};

export const KNOWN_WIDGET_KEYS = Object.keys(WIDGET_RENDERERS);
